import gsap from "gsap";

export function load() {
    window.addEventListener('DOMContentLoaded', function () {
        gsap.config({ nullTargetWarn: false });

        gsap.set('.js-hamburger', { x: 0 }); // ハンバーガーメニューを左端に配置

        // GSAP タイムラインを作成
        var tl = gsap.timeline({});
        // CSSで最初は非表示に設定
        gsap.set('.c-load', { autoAlpha: 1 });
        gsap.set('.js-mv', { autoAlpha: 0 });
        gsap.set('.js-mv__lead', { autoAlpha: 0 });
        gsap.set('.js-mv-img', { scale: 1.1 });
        gsap.set('.js-content', { autoAlpha: 0 });
        gsap.set('.p-header', { autoAlpha: 0, y: "-100%" });
        gsap.set('#js-scrollTop', { autoAlpha: 0 }); // ボタンを非表示にする

        tl.fromTo('.c-load',
            { autoAlpha: 1 },
            { autoAlpha: 1 }
        )
            .to('.c-load', {
                autoAlpha: 0,
                duration: 0.8,
            })
            .to('.js-mv-img', {
                delay: .1,
                scale: 1,
                duration: 1.2,
            })
            .to('.js-mv', {
                autoAlpha: 1,
                duration: 1.2,
            }, '<')
            .to('.js-mv__lead', {
                autoAlpha: 1,
                duration: 1.5,
            }, '<')
            .to('.p-header', {
                autoAlpha: 1,
                y: "0%",
                duration: 1.2,
            }, '<')
            .to('.js-content', {
                autoAlpha: 1,
                duration: 1.5,
                delay: .8,
            }, '<');

        // アニメーションが完了した後にoverflowプロパティを再設定する
        tl.call(() => {
            document.body.style.overflow = ''; // overflowプロパティをリセット
            // アニメーションが実行されたことをセッションストレージに記録
            sessionStorage.setItem('animationPlayed', 'true');
            applyFinalStyles(); // 最終スタイルを適用
        });

        // スクロールイベントリスナーを追加してボタンを表示
        window.addEventListener('scroll', scrollHandler);
    });
}

let lastScrollPosition = 0; // 直前のスクロール位置を記録する変数を定義

function scrollHandler() {
    // 現在のスクロール位置を取得
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    // スクロール位置が300pxより大きくかつ直前のスクロール位置が300px以下の場合にボタンを表示
    if (scrollPosition > 300 && lastScrollPosition <= 300) {
        gsap.to("#js-scrollTop", { autoAlpha: 1, display: 'flex', duration: 0.5, delay: 2 }); // ボタン表示を3秒遅らせる
    } else if (scrollPosition <= 300) { // スクロール位置が300px以下の場合はボタンを非表示
        gsap.to("#js-scrollTop", { autoAlpha: 0, display: 'none', duration: 0.5 });
    }

    // 現在のスクロール位置を保存
    lastScrollPosition = scrollPosition;
}



// トップへ戻るボタンのクリックイベントリスナー
document.getElementById("js-scrollTop").addEventListener("click", () => {
    gsap.to(window, {
        duration: 1,
        scrollTo: {
            y: 0,
            autoKill: false
        }
    });
});

function applyFinalStyles() {
    // アニメーション完了時に適用されるスタイルをここに記述
    gsap.set('.c-load', { autoAlpha: 0 });
    gsap.set('.js-mv', { autoAlpha: 1 });
    gsap.set('.js-mv__lead', { autoAlpha: 1 });
    gsap.set('.js-mv-img', { scale: 1 });
    gsap.set('.js-content', { autoAlpha: 1 });
    gsap.set('.p-header', { autoAlpha: 1, y: "0%" });
    gsap.set('.js-hamburger', { x: 0 }); // ハンバーガーメニューを左端に配置
    // gsap.set('#js-scrollTop', { autoAlpha: 1 }); // ローディングアニメーション完了後にボタンを表示する
    // その他必要なスタイルがあればここに追加
}
